<div class="flex flex-wrap mt-4 gap-4 justify-center mb-4">
  <!-- Create 2 buttons - one with link and icon of bdomobile. Second to youtube with youtube logo and colors-->
  <p-button
    [aria-label]="'ui.createCompanyInstructions.instructionLabel' | translate"
    styleClass="text-white bg-blue-600"
    (onClick)="openWikiPage()"
  >
    <i class="pi pi-flag"></i> {{ 'ui.createCompanyInstructions.instruction' | translate }}
  </p-button>

  <p-button
    styleClass="text-white bg-red-600"
    [aria-label]="'ui.createCompanyInstructions.tutorialVideoLabel' | translate"
    (onClick)="openTutorialVideo()"
  >
    <i class="pi pi-play"></i> {{ 'ui.createCompanyInstructions.tutorialVideo' | translate }}
  </p-button>

  <p-button
    styleClass="text-white bg-green-700"
    [aria-label]="'ui.createCompanyInstructions.contactUsLabel' | translate"
    (onClick)="openContactMail()"
  >
    <i class="pi pi-envelope"></i> {{ 'ui.createCompanyInstructions.contactUs' | translate }}
  </p-button>
</div>
